import WheelContainer from "containers/organisms/WheelContainer";
import { SEO } from "utils/helmet/components/SEO";

interface Props {
  pathname: string;
}

const WheelPage = (props: Props) => {
  const { pathname } = props;

  return (
    <>
      <SEO pathname={pathname} />
      <WheelContainer />
    </>
  );
};

export default WheelPage;
